<template>
  <router-view></router-view>
</template>

<script>
import { checkCurrentUserExist } from './utils/auth.js'
export default {
  methods: {
    initializeLayout() {
      if (!this.$rtl.isRTL) {
        // Just make sure rtl css is off when we are not on rtl
        this.$rtl.disableRTL();
      }
    }
  },
  mounted() {
    checkCurrentUserExist()
    this.initializeLayout();
  }
};
</script>
